import { ToolbarDistanceIcon } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'
import { InspectionItemType } from '@editor/interfaces/inspection'

import useElementsPanel from './hooks/useElementsPanel'
import useMainCanvas from './hooks/useMainCanvas'

const CustomMeasurement: EditorTool = {
  key: EDITOR_TOOLS.CUSTOM_MEASUREMENT,
  cursor: CursorState.CROSSHAIR,
  authCheck: () => true, // anyone can use this tool. how it behaves will differ but those will be handled in the tool's implementation.
  toolbar: {
    icon: <ToolbarDistanceIcon width="50%" height="50%" />,
    label: EDITOR_TOOLS_LABELS.CUSTOM_MEASUREMENT,
    category: ToolbarCategory.Manipulate,
  },
  hooks: {
    useMainCanvas,
    useElementsPanel,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
    },
    selectableInspectionItems: [InspectionItemType.LengthWithDistanceTool],
  },
}

export default CustomMeasurement
